import type { IAudienceTemplateConfig } from '@/Interfaces/AudienceTemplates/AudienceTemplate.interface';
import type { IBaseAudienceTargeting } from '@/Interfaces/Audiences/Audience.interface';
import type { IAudienceControlOption } from '@/Interfaces/ControlOption.interface';

export interface IAppliedTemplate {
  value: IBaseAudienceTargeting<IAudienceControlOption<number>>;
  missingCount: number;
}

export const applyTemplateConfig = (
  config: IAudienceTemplateConfig,
  options: IAudienceControlOption<number>[],
): IAppliedTemplate => {
  const byId = new Map(options.map(option => [option.value, option]));
  let missingCount = 0;

  const resolve = (id: number): IAudienceControlOption<number> | null => {
    const option = byId.get(id);
    if (!option) {
      missingCount += 1;
      return null;
    }
    return option;
  };

  const isResolved = (option: IAudienceControlOption<number> | null): option is IAudienceControlOption<number> =>
    option !== null;

  const include = (config.include ?? [])
    .map(group => group.map(resolve).filter(isResolved))
    .filter(group => group.length);

  const exclude = (config.exclude ?? []).map(resolve).filter(isResolved);

  return { value: { include, exclude }, missingCount };
};
